import { render } from "./popUpReportarErro.vue?vue&type=template&id=71e292ca&scoped=true"
import script from "./popUpReportarErro.vue?vue&type=script&lang=js"
export * from "./popUpReportarErro.vue?vue&type=script&lang=js"

import "./popUpReportarErro.vue?vue&type=style&index=0&id=71e292ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e292ca"]])

export default __exports__